module.exports = __webpack_public_path__ + "img/img-profile-placeholder.50608113.png";